import { Select, Tooltip, Dropdown, Menu, Modal, Button } from 'antd';
import styles from "./callsTranscript.module.scss";
import { URInputwithLabel } from '../../../../shared/widgets/inputwithLable';
import { URInput } from '../../../../shared/widgets/input';
import { URCheckBox } from '../../../../shared/widgets/checkbox';
import { URButton } from '../../../../shared/widgets/button';
//import transhighlight from "../../../../styles/images/langtranshighlight.svg";
import React, { useEffect, useState } from "react";
import store from '../../../../context/store/store';
import ContactLoader from "../../../../styles/images/Lottie Animation.json";
import {
  asrSearchLanguage, callActionChanges,
  DataURIToBlob,
  dwldCallTranscript,
  finalShare,
  getCurrentCallDetail,
  logInfo,
  searchAudioTranscript,
  textToPdfBlobVMtrans,
  toastInformation,
  userStatusColor
} from '../../../../base/callService/common';
import { useSelector } from 'react-redux';
import noDataStyle from "../../leftsidebar/noCalls/noCalls.module.scss";
import { URAvatarGroup } from '../../../../shared/widgets/avatarGroup';
import { URStatusDot } from '../../../../shared/widgets/avatarGroup/statusDot';
import { Highlights } from './highlight';
import { transcriptionSearch } from '../../../../base/callService/asrTTS';
import { Types } from '../../../../context/action/action';
import { contactService } from '../../../../base/contactService';
import { init_ASR } from '../../../../models/callModel';
import { automatedMintsStore } from '../../../../base/callService/store_mining';
import CallsEditShareTrans from '../callsEditShareTrans';
import Lottie from 'lottie-react';
import groovyWalkAnimation from "../../../../styles/images/chat blank state loading.json";
import kebabnormal from "../../../../styles/images/kebabgrey.svg";
import kebabhover from "../../../../styles/images/kebabhover.svg";
import kebabactive from "../../../../styles/images/kebabgreen.svg";
import filtericon from "../../../../styles/images/filtericon.svg"; 
import filtergrey from "../../../../styles/images/filtergrey.svg";
import filteractive from "../../../../styles/images/filteractive.svg"; 
import closegrey from "../../../../styles/images/closegrey.svg"; 
import closehover from "../../../../styles/images/closehover.svg"; 
import scrolldown from "../../../../styles/images/scrolldown.svg"; 
import taskimg2 from "../../../../styles/images/task2.svg";
import dwld from "../../../../styles/images/dwld.svg";
import moment from 'moment';
import _ from 'lodash';
import { setAutoDwld, storeAudioTranscript } from '../../../../base/socketChatService/newChat';
import jsPDF from 'jspdf';
import { SearchFilter, getCookie, getcontactDetail } from '../../../../base/utils';
import { LoginState, initialStateModel } from '../../../../models/model';
import axios from 'axios';
import { config } from '../../../../base/constant';
type CallTranscriptState = {
  asr_Search: string;
  visible: boolean;
  isSearch: boolean;
  search: string;
  nextIndex: number;
  default_FilterBy: any;
  trans_FilterBy: any;
  totalSearched: any;
  isEdit: boolean;
  isfliterVisible: boolean;
  transcriptData:Array<any>;
  kebabIcon:boolean;
  scrollTrans:boolean;
  isModalVisibleShare:boolean;
};
export default function ChatTranscript() {

  let {audioTranscript}=store.getState().closeCaption;
  const [getData, setData] = useState<CallTranscriptState>
  ({
    asr_Search: '',
    visible: false, isSearch: false, isfliterVisible: false, search: '', nextIndex: 0,
    trans_FilterBy: [], default_FilterBy: [],totalSearched:'',isEdit:false,transcriptData:audioTranscript,kebabIcon:false,scrollTrans:false,isModalVisibleShare:false
  });
  const { closeCaption }: init_ASR = useSelector((state: init_ASR) => state);
  let { totalSearched } = getData;
  let ASR_Data: any = store.getState().ASR_Language || [];
  let asrLanguage = asrSearchLanguage(ASR_Data.list, getData.asr_Search);
  let ast_defaultOpt = closeCaption.updatedLanguages.transcription_code || 'en';
  let transcriptLoading=closeCaption.transcriptLoading;
  let transcriptEnable=closeCaption.transcriptEnable;
  let autoDwld=closeCaption.autoDwld;
  let transcriptShow: any;
  let commonDetail: any;
  let loggedUserDetails: any = store.getState().loginReducer.userdetails || [];
  let title: string;
  const {allContacs} =  useSelector((state: initialStateModel)=> 
 state.contactReducer);
  const voicemailList = closeCaption?.voicemailTrans || '';
  const [shareContact, setshareContact] = useState<any>({
    contactList: allContacs, searchContactList:allContacs, contactDetail: [],
    selectedmember: [],selectedsavedMsg :{}
  });  
  console.log("SHARE CONTACT",shareContact)
  const [recShareModal, setRecShareModal] = useState<any>(false);
  console.log("recShareModalrecShareModal",recShareModal)
  const [shareButtonEnabled, setShareButtonEnabled] = useState(false);


  if (closeCaption.asrCallingFrom === 'callList') {
    let activeCallDetail: any = getCurrentCallDetail();
    commonDetail = activeCallDetail.contact || [];
    title = 'Call';   
    // participantName = userData['caller_id'] || "Unknown";
    transcriptShow = closeCaption.transcripts;
  }
  else
  {
    let { particularLog } = store.getState().callReducer || [];
    commonDetail = particularLog;
    title = closeCaption.asrCallingFrom === 'voiceMail' ? 'Voicemail' : 'Recorded';
    transcriptShow = closeCaption.voiceTranscript;


  }

  const onSearchMembers = (value: any) => {
    let response = SearchFilter(shareContact.contactList, value.toLowerCase());
    setshareContact({ ...shareContact, searchContactList: response });
  };

  const onChangeSelectMemb =(member:any)=>{
    let {userdetails}:LoginState = store.getState().loginReducer;
    let contact:any=
    member.map((item:string,index:any)=>
    {
      return getcontactDetail(item.toString(),shareContact.contactList,userdetails);
    });
    setshareContact({
      ...shareContact, selectedmember: member,
      searchContactList: shareContact.contactList,contactDetail:contact
    });
    let combinedArray = contact && contact.length > 0 ? contact : [];
    setShareButtonEnabled(combinedArray.length > 0);
  };

  const closeRecShareModal=()=>{
    setRecShareModal(false);
    setshareContact({
      ...shareContact,
      selectedmember: [],
      contactDetail: []
    });
  }
  
  const open_transc_language = () => {
    setData({ ...getData, visible:true});
  };

  const handle_Trans_VisibleChange = (flag:any) => {
    setData({ ...getData, visible:flag});
  };

  const textBoxOnchange = (keyPress: any) => {
    setData({ ...getData, asr_Search: keyPress.target.value });
  };

  const updateLanguageSelection = (lanChar:string,lanStr:string) => {

    store.dispatch({
      type: Types.ASR_LANG_UPDATE,
      payload: {
        transcription_str:lanStr,
        transcription_code:lanChar
      }
    });
    setData({ ...getData, visible: false });

    if (closeCaption.asrCallingFrom === 'callList') {
      let trans: any = {
        transcripts:JSON.stringify(transcriptShow),
        targetLang:lanChar
      };
      contactService.getlanTranslation(trans);
    }
    //else { languageUpdateAnother(lanChar); }
  };
  const searchSwap = () => {
    setData({ ...getData, isSearch: !getData.isSearch, search: '', nextIndex: 0 });
  };
  const handleVisibleChange = (flag:any) => {
    setData({ ...getData, isfliterVisible: flag });
  };
  const handleFliterVisible = () =>{

    setData({ ...getData, isfliterVisible: !getData.isfliterVisible });
  };
  const checkHighlight =(e:any)=>{
    //setScriptInfo({ ...scriptInfo, byHighlight: e.target.checked});
  };

  // const fliter_Clk_Click = (status:string) => {

  //   if (status === 'cancel') {
  //     setData({ ...getData, isfliterVisible: false });
  //   }
  //   else {
  //     if()
  //     let filtered:any={};
  //     let output = audioTranscript.filter(function (obj: any) {
  //       const text = `${obj.finalText}`.toLowerCase()
  //       const fin = getData.trans_FilterBy.some((check:any) => text.includes(check))
  //       return fin ?? obj.finalText
  //      });
  //      storeAudioTranscript(output);
  //     setData({ ...getData, isfliterVisible: false, transcriptData: filtered,trans_FilterBy:[]});
  // }
  // };

  const handleOnSearch = async(e: any) => {
    setData({ ...getData, search: e.target.value,nextIndex:0 });
    let filterSearchText: any = await document.getElementsByClassName('searchedKey');
    if (filterSearchText[0]) {
      filterSearchText[0].style.backgroundColor = 'rgb(179,215,250)';
      filterSearchText[0].style.borderBottom = "2px solid #68AFF5";
    }
  };

  // const copyTranscription = () => {
  //   let str = '';
  //   transcription.forEach((element: any) => {
  //     if (closeCaption.asrCallingFrom === 'callList') {
  //       str += element.speakerName + ":\r\n" +
  //       "\t"+element.text +"\r\n";
  //     }
  //     else { str += element.text +"\r\n"; }
  //   });
  //   navigator.clipboard.writeText(str);
  //   toastInformation('Copied', "success");
  // };

  const copy_updated_language = () => {
    let str = '';
    transcriptShow.forEach((element: any) => {
      if (closeCaption.asrCallingFrom === 'callList') {
        str += element.speakerName + ":\r\n" +
          "\t" + element.convertedText + "\r\n";
      }
      else {
        str += element[closeCaption.updatedLanguages.transcription_code] +"\r\n";
      }
    });
    navigator.clipboard.writeText(str);
    toastInformation('Copied', "success");
  };
  const share_updated_language = () => {

    let { leftSideWindow } = store.getState().updatedCallList || [];
    automatedMintsStore('summaryShare',leftSideWindow,'updateLanguage');
  };

  const outPutLangSelection = (
    <div className={styles.autoTranslateLangs}>
      {/* <span className={styles.topsecTxtTitle}>Record Spoken language</span> */}
      <div className={styles.searchBox}><URInput placeHolder='Search'
        className='searchBoxlanglist' onChange={textBoxOnchange} /></div>
      <ul className={`scroller ${styles.langList}`}>
        {asrLanguage.map((elem: any, index: number) => {
          return (<li key={index} className={ast_defaultOpt === elem.languageCode?`${styles.selected } ${styles.active }` :styles.selected}  
            onClick={() => updateLanguageSelection(elem.languageCode,elem.languageName)}>
          
              <span className={ast_defaultOpt === elem.languageCode?`icon_tick  ltick` : 'icon_tick'} ></span>
            {elem.languageName + " (" + elem.languageCode + ")"}</li>
          );
        })
        }  
      </ul>
      
    </div>
  );

  const onChangeSelectMembers = (e: any) => {
    let output:any=[];
if(e.length > 0)
     {output = audioTranscript.filter(function (obj: any) {
      return (e).includes(obj.speakerName);
    })}
    else{
      output=audioTranscript;
    }
    //  storeAudioTranscript(output,transcriptLoading,transcriptEnable);
    setData({ ...getData, isfliterVisible: false, transcriptData: output,trans_FilterBy:e});
  };

  const clearFilter=()=>{
    setData({ ...getData, isfliterVisible: false, transcriptData: audioTranscript,trans_FilterBy:[]});
  }

  const enableAutoDownload=()=>{
    setAutoDwld(true);
  }
  const saveTranscript=()=>{
dwldCallTranscript();
      }
  let activeCallDetail: any = getCurrentCallDetail();
  let userData:any = activeCallDetail.contact || [];
  const filtermenu = (
    <div className={styles.filtermains}>
      <div className={styles.toplayers} onClick={clearFilter}>
        <h3>Filter <span>Clear Filter(s)</span></h3>
      </div>
      <div className={styles.midlayers}>
        <label>Select Participants</label>
        <div className={styles.insideicon}>
        {getData.trans_FilterBy.length === 0 && <img src={taskimg2} alt="" />}
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Enter name / extension "
          className={getData.trans_FilterBy.length === 0 ? "newselects taskcreations customdropbox ":"newselects taskcreations customdropbox inputselectlftnone"}
          dropdownClassName="newChatSel meetingdropdown ztopset"
          onChange={(e: any) => onChangeSelectMembers(e)}
        >
          {/* <option value={''}></option> */}
          <option value={ loggedUserDetails['caller_id'] }>
            <div className="dropdowndesign">
              <div className="usergroups">
                <span>{loggedUserDetails['caller_id'] && (
                  (loggedUserDetails['caller_id']).charAt(0)).toUpperCase()}<b></b></span></div>
              <div className="names">{ loggedUserDetails['caller_id'] }</div>
              <div className="ext">{ loggedUserDetails['ext'] }</div>
            </div>
          </option>
          <option value={ userData['caller_id'] }>
            <div className="dropdowndesign">
              <div className="usergroups">
                <span>{userData['caller_id'] &&(
                  (userData['caller_id']).charAt(0)).toUpperCase()}<b></b></span></div>
              <div className="names">{ userData['caller_id'] }</div>
              <div className="ext">{ userData['ext'] }</div>
            </div>
          </option>
        </Select>
        </div>
       
      </div>
      {/* <div className={styles.bottomlayers}>
        <URButton name='Cancel' className="urButton buttonWhite" onClick={()=> fliter_Clk_Click('cancel')}/>
        <URButton className="urButton buttonBlue marlftmin" name='Apply' onClick={()=>fliter_Clk_Click('apply')}/>
      </div> */}
    </div>
  );
  const moremenu = (
    <div className={styles.filtermains}>
      <div className={styles.toplayersmore}>
        <ul>
          <li onClick={saveTranscript}><img src={dwld}></img><p>Save Transcript</p></li>
          <li className={styles.checkboxlft}>  <URCheckBox  checked={autoDwld}   onChange={enableAutoDownload}/> <p>Auto Download</p></li>
        </ul>
        
      </div>
    </div>
  );

  const downloadVoicemailTrans = (voicemailText: string) => {
    if (!voicemailText || voicemailText === "data not found") {
      toastInformation("No transcription data available to download.", "error");
      return;
    }
    const cleanText = voicemailText.replace(/\s+/g, ' ').trim()
    textToPdfBlobVMtrans(cleanText, "Voicemail_Transcript");
    toastInformation("Success! Voicemail PDF downloaded", "success");
  };
   
  const modalShareVMtrans =()=>{
    setRecShareModal(true)
  }

  const voicemailTrans = () => (
    <Menu>
    <Menu.Item onClick={() => downloadVoicemailTrans(closeCaption.voicemailTrans)}>Download</Menu.Item>
    <Menu.Item onClick={modalShareVMtrans}>Share</Menu.Item>
  </Menu>
  );

  const shareTranscription =()=> {

    // let { leftSideWindow } = store.getState().updatedCallList || [];
    // automatedMintsStore('summaryShare',leftSideWindow,'Transcription');
    setData({ ...getData, isEdit: true });
  };
  
  const findPrevious = (e: any) => {
    try {
      var searchedTags: any = document.getElementsByClassName('searchedKey');
      if (searchedTags) {
        let count: number =getData.nextIndex===0? searchedTags.length-1: getData.nextIndex-1;
        if (count < 0) { count = searchedTags.length - 1; }
        searchedTags[count].focus();
        searchedTags[count].style.backgroundColor = 'rgb(179,215,250)'
        searchedTags[count].style.borderBottom = "2px solid #68AFF5";
        searchedTags[getData.nextIndex === searchedTags.length ?
          getData.nextIndex - 1 : getData.nextIndex].style.backgroundColor = "#FFFF00";
          searchedTags[getData.nextIndex === searchedTags.length ?
            getData.nextIndex - 1 : getData.nextIndex].style.borderBottom = "2px solid #FBE880";
        
        setData({ ...getData, nextIndex: count});
      }
    }
    catch (e:any) { logInfo("findPrevious error is", e); }
  };

  const findNext = () => {
    try {
      var searchedTags: any = document.getElementsByClassName('searchedKey');
      if (searchedTags && getData.search !== '') {
        let count: number;
        if (getData.nextIndex === 0) { count = 0; }
        count = getData.nextIndex === searchedTags.length-1 ?
          0 : getData.nextIndex + 1;
        if (count > searchedTags.length) { count = 1; }
        searchedTags[count].focus();
        searchedTags[count].style.backgroundColor = 'rgb(179,215,250)'
        searchedTags[count].style.borderBottom = "2px solid #68AFF5";
        searchedTags[getData.nextIndex].style.backgroundColor = "#FFFF00";
        searchedTags[getData.nextIndex].style.borderBottom = "2px solid #FBE880";
        setData({ ...getData, nextIndex: count });
      }
    }
    catch (e:any) { logInfo("findNext error is", e); }
  };

  let newTaskList:any = [];
  closeCaption.tasklist.map((tasks: any) => {
    newTaskList.push(tasks.selectkey);
  });
  
  // let transcription = transcriptionSearch(getData.search, transcriptShow, getData.trans_FilterBy);
  // let highlight_search = getData.search === "" ? [...closeCaption.highlights, ...newTaskList]
  //   : [...closeCaption.highlights, getData.search];
  
  const gotoBottom_Transcript = (id: string) => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.scrollTop = element?.scrollHeight - element?.clientHeight;
    }
  };

  const backToCurrentPage = () => { setData({ ...getData, isEdit: false }); };


  
  const closeTranscription = () => { callActionChanges('transcript'); };

  // useEffect(() => {
  //   if (getData.search === "") { gotoBottom_Transcript("transcription_Div"); }
  //   if (getData.search === "" && closeCaption.updatedLanguages.transcription_code !== 'en') {
  //     gotoBottom_Transcript("transcription_update_lan");
  //   }

  //   if (totalSearched !== document.getElementsByClassName('searchedKey')?.length) {
  //     setData({ ...getData, totalSearched: document.getElementsByClassName('searchedKey')?.length });
  //   }
  // }, [transcription]);

  useEffect(()=>{
if(getData.search !== ""){let filtered = _.filter(audioTranscript, function (elem: any) {
  return elem.finalText?.toLowerCase()?.includes(getData.search?.toLowerCase()) || elem.speakerName?.toLowerCase()?.includes(getData.search?.toLowerCase())
});

setData({ ...getData, transcriptData: filtered});}
  },[audioTranscript.length,getData.search])


  useEffect(()=>{
    if(!getData.scrollTrans){
      requestAnimationFrame(() => {
      const container = document.getElementById('transcription_Div');
      if(container){container.scrollTop = container.scrollHeight;}
    });}
  },[audioTranscript[audioTranscript?.length-1]?.finalText?.length,getData.scrollTrans])

  const searchCallTranscript=(e:any)=>{
    if (e.target.value !== "") {
      let filtered = _.filter(audioTranscript, function (elem: any) {
        return elem.finalText?.toLowerCase()?.includes(e.target.value?.toLowerCase()) || elem.speakerName?.toLowerCase()?.includes(e.target.value?.toLowerCase())
      });
      
      setData({ ...getData, transcriptData: filtered,search: e.target.value});
  }
  else {
    setData({ ...getData, transcriptData: audioTranscript,search:"" });
  }
  }

  const setKebabMenu=(e:any)=>{
setData({...getData,kebabIcon:e})
  }

  const scrollToBottom=()=>{
setData({...getData,scrollTrans:false})
}

  const Scroll=(e:any)=>{
    const container = document.getElementById('transcription_Div');
    if(container){        
      if(((Math.round(container.scrollTop+ container.clientHeight)) === container.scrollHeight)|| ((Math.round(container.scrollTop+ container.clientHeight)+1) === container.scrollHeight)){
        setData({...getData,scrollTrans:false})
    }
     if((Math.round(container.scrollTop+ container.clientHeight)+1) < container.scrollHeight){
      setData({...getData,scrollTrans:true})
    }
  }
}

  let len = Math.round((getData.transcriptData.length / 8)) > 0 ? 10 : 1;
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  const shareFile = async (type: any) => {
    var str = title;
    str = str?.replace(/\s+/g, '_'); // Optional, to clean up the title string.
  
    const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;
    const token: any = getCookie("ssoToken");
  
    const authkey = {
      "Content-Type": "multipart/form-data",
      Authorization: token
    };
    
    // Check if we are dealing with a voicemail
    if (closeCaption?.asrCallingFrom === "voiceMail") {
      const voicemailText = closeCaption?.voicemailTrans || "";
  
      if (!voicemailText || voicemailText === "data not found") {
        toastInformation("No voicemail transcription available to share.", "error");
        return;
      }
  
      const cleanedText = voicemailText.replace(/\s+/g, ' ').trim();
  
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4"
      });
  
      const marginLeft = 40;
      const marginTop = 60;
      const maxWidth = 520;
  
      doc.setFontSize(12);
      doc.text("Voicemail Transcript", marginLeft, marginTop);
      doc.setFontSize(10);
      doc.setTextColor(75);
      doc.text(doc.splitTextToSize(cleanedText, maxWidth), marginLeft, marginTop + 30);
  
      const pdfBlob = doc.output("blob");
      const fileName = "Voicemail_Transcript.pdf";
  
      const formData = new FormData();
      formData.append("doc", pdfBlob, fileName);
  
      try {
        const response = await axios.post(url, formData, { headers: authkey });
        console.log("File uploaded:", response.data.files);
  
        const files = response.data.files;
        const pdfFile = files.find((file: any) => file.mimetype === "application/pdf");
  
        if (pdfFile) {
          console.log("PDF File found:", pdfFile);
          if (pdfFile ) {
            const shareContactCopy = shareContact?.contactDetail?.map((elem: any)=> {
            return {
              email: elem?.email_id,
              ext: elem?.ext,
              jid: elem?.jid,
              name: elem?.caller_id,
              profile_img:elem?.ImageURL,
              roletype: '',
              sipid: elem?.sip_login_id,
              user_type:'',
              team_id: elem?.team_id?.toString() ?? '',
              chattype: elem?.team_id ? 'group':  'one'
            }
            }
            )
            const reorderedShareContactCopy = shareContactCopy.sort((a: any, b: any) => {
              if (a.chattype === "one" && b.chattype !== "one") return -1;
              if (a.chattype !== "one" && b.chattype === "one") return 1;
              return 0;
            });
            finalShare([pdfFile], reorderedShareContactCopy, fileName);
            toastInformation("Voicemail PDF shared successfully!", "success");
          } else {
            toastInformation("No file found after upload.", "error");
          }
        } else {
          toastInformation("No valid PDF file found after upload.", "error");
        }
      } catch (error) {
        console.error("Upload error:", error);
        toastInformation("Failed to upload voicemail PDF.", "error");
      }
    }
  };
  
  
  return (
    <>
      {!getData.isEdit ?
        (
          <div className={`${styles.chatDialPadContainer} animate__animated animate__fadeIn animate__faster`}>
            <div className={styles.chatsharefile}>
         
                  <div className={styles.topHeaderShareSec}>
                    <h4>Transcription</h4>
                    <ul className='activedropbgset'>
                      {getData.transcriptData.length !== 0 &&
                        <>
                          {/* {closeCaption.asrCallingFrom === 'callList' && */}
                          
                            <><li className={`${styles.filterdrops}`}> <Tooltip title='Filter' placement="left">
                              <Dropdown overlay={filtermenu} trigger={['click']} onVisibleChange={handleVisibleChange}
                                visible={getData.isfliterVisible}>
                                {<span  onClick={handleFliterVisible}>
                                  <img src={!getData.isfliterVisible ? filtericon : filtergrey}></img></span>}
                               
                              </Dropdown>
                            </Tooltip></li>
                            {closeCaption?.asrCallingFrom === "callList" && (
                            <li className={styles.kebabicon}> <Tooltip  placement="left">
                              <Dropdown overlay={moremenu} trigger={['click']} onVisibleChange={setKebabMenu} visible={getData.kebabIcon}>
                                <span>
                                  {!getData.kebabIcon &&<img src={kebabnormal} />}
                                {getData.kebabIcon && <img src={kebabhover} />}
                                </span>
                              </Dropdown>
                            </Tooltip></li>)}
                            </>

                          {/* } */}

                        </>
                      }
                       {closeCaption?.asrCallingFrom === "voiceMail" && (
                                <li>
                                  <Dropdown overlay={voicemailTrans}>
                                  <img src={kebabhover}/>
                                  </Dropdown>
                                </li>
                              )}

                              <Modal
                                title="Share Voicemail Transcript"
                                visible={recShareModal}
                                className="clipShare"
                                footer={[
                                  <>
                                    <Button key="cancel" className="ShareClipscancel" onClick={closeRecShareModal} >Cancel</Button>
                                    <Button 
                                          key="Share"
                                          className={`${shareButtonEnabled ? 'clipmodbtnactive' : 'clipmodbtndisable'}`}
                                          onClick={() => {
                                            shareFile("record");
                                            closeRecShareModal(); 
                                          }}
                                          disabled={!shareButtonEnabled}
                                        >
                                          Share
                                        </Button>

                                  </>
                                ]}
                                onCancel={closeRecShareModal}
                              >
                                {/* <p>Voicemail transcript will be shared as a PDF file.</p> */}
                                      <Select
                                    mode="multiple"
                                    onChange={(data: any) => onChangeSelectMemb(data)}
                                    onSearch={onSearchMembers}
                                    style={{ width: '100%' }}
                                    filterOption={false}
                                    showSearch={true}
                                    value={shareContact.selectedmember}
                                    placeholder="Search Name/ Group/ Extension"
                                    className="createNewSel"
                                    dropdownClassName="newChatSel">
                                    { shareContact?.searchContactList?.map((contact:any,index:any)=>{
                                      let nameList= contact?.caller_id ?contact?.caller_id : contact?.team_name;
                                      return(
                                        <option key={index}
                                          value={contact.sip_login_id?contact.sip_login_id: `con${contact.team_id}`}>
                                          <div className="dropdowndesign">
                                            <div className="usergroupss">
                                              <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                                                {contact.ImageURL || contact.profile_image_url?
                                                  <><img alt="" src={contact.ImageURL?contact.ImageURL:contact.profile_image_url}/>
                                                    <URStatusDot
                                                      className={userStatusColor(contact?.user_status,'small')}/></>:
                                                  <span>{nameList?.charAt(0).toUpperCase()}<URStatusDot
                                                    className={userStatusColor(contact?.user_status,'small')}/></span>
                                                }
                                              </> } />
                                            </div>
                                            <div className="names">{nameList && nameList}</div>
                                            {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                                          </div>
                                        </option>
                                      
                                      );
                                    })  
                                  }
                                
                                  </Select>
                              </Modal>

                      <li className ={styles.closeicon} onClick={closeTranscription}>
                        <Tooltip title='Close' placement="top"> <span>
                          <img src={closegrey}></img>
                          </span></Tooltip></li>
                    </ul>
                  </div>


              <div className={styles.topinnerSecCon}>
                <div className={styles.twiesConsec}>
                  <div className={styles.shareFileConSecScroll}>
                  {closeCaption?.asrCallingFrom !== "voiceMail" && <URInput placeHolder="Search" className="leftbarsearch" onChange={searchCallTranscript}></URInput>}
                  {(closeCaption?.asrCallingFrom !== "voiceMail" && getData?.transcriptData?.length === 0 &&!transcriptLoading)&&<div className={noDataStyle.noMessage}>
                        <div className={noDataStyle.noMessageinner}>
                          <p className={noDataStyle.noMessageTitle}>No Data Found</p>
                          <div className={noDataStyle.recentBtn}>
                            <span className="icon_outlineleftarrow"></span>
                            <span onClick={closeTranscription}>no detail</span>
                          </div>
                        </div>
                    </div>
                    }

                    {(
                       ((getData?.transcriptData?.length === 0 &&
                       getData?.search === '' && closeCaption?.asrCallingFrom === "callList") ||    (closeCaption?.asrCallingFrom === 'voiceMail' && !voicemailList)) &&
                        transcriptLoading 
                      
                        ) && (
                        <div className={noDataStyle.noMessage}>
                        <div><Lottie className="svgLoading forchatsvg" animationData={ContactLoader} /></div>
                        </div>
                       )}
                    <div className={`${styles.launConSec} ${styles.langHighlight}`}>
                      {getData.transcriptData.length !== 0 && !transcriptLoading &&
                        <ul>
                    
                          {/* <li onClick={copyTranscription}>
                            <Tooltip title='Copy' placement="top"><span className="icon_copydoc"></span></Tooltip></li>
                          <li onClick={shareTranscription}>
                            <Tooltip title='Share' placement="top"><span className="icon_reply"></span></Tooltip></li> */}
                        </ul>
                          }
                    </div>
              
                    <div className={`scrollerhover ${styles.contentCon}`} id="transcription_Div" onScroll={Scroll}>
                       
                    {(closeCaption?.asrCallingFrom === 'voiceMail' && voicemailList === "data not found")  ? (  <div className={styles.middlemainconsec}><p className={styles.nodatafound}>No Data Found</p></div> ) : (closeCaption?.asrCallingFrom === 'voiceMail' && voicemailList) ? (
    <div className={styles.contentConinner}>
      <p>
        <span className={styles.tstamp}></span><br />
        <div className={styles.transText}>
          {/* <b>{particularLog?.caller_id}</b> */}
          <p>{voicemailList}</p>
        </div>
      </p>
    </div>
  ) : (
                       
                       getData?.transcriptData.map((elem: any, index: any) => {
                         let searchh: any = searchAudioTranscript(elem, getData.search);
                        //  let searchName: any = searchAudioTranscriptName(elem, getData.search)
                        return (
                          <div className={styles.contentConinner} key={index}>
                            {closeCaption.asrCallingFrom === 'callList' &&
                              <URAvatarGroup className={`lefts size28 colorBG${random_color[index]}`}profileInfo={<><span>
                                {`${elem.first_name?.toUpperCase()?.charAt(0)}${elem.last_name?.toUpperCase()?.charAt(0)}`}</span>
                              <URStatusDot className='stsDot green' /></>} />
                            } 
                            <p>
                            {/* {(searchName?.middleMsg !== "" && getData.search !== "") ?
                          <b>{searchName?.firstMsg}
                            < span className={'highlight1'} tabIndex={index}>{searchName?.middleMsg}</span>{searchName?.lastMsg}</b> : (getData.search  !== "" && searchName?.middleMsg === "") ?
                            <b>{elem.speakerName}</b> : <><b>{elem.speakerName}</b></>} */}
                                <b>{elem.speakerName}</b><span className={styles.tstamp}>{moment(elem.timeStamp).format("hh:mm A")}</span><br />
                              
                               <div className={styles.transText}>
                              {/* <Highlights highlight={(getData.search).toLowerCase()}
                                searchWords={highlight_search} tasklist={newTaskList}
                                removehighlight={closeCaption.highlights}> */}
                                       {(searchh?.middleMsg !== "" && getData.search !== "") ?
                          <p>{searchh?.firstMsg}
                            < span className={'highlight1'} tabIndex={index}>{searchh?.middleMsg}</span>{searchh?.lastMsg}</p> : (getData.search  !== "" && searchh?.middleMsg === "") ?
                            <p>{elem.finalText}</p> : <><p>{elem.finalText}</p></>} 
                                  {/* </Highlights> */}
                                  </div>
                            </p>
                           </div>
                           );
                          }))}             
                          {getData.scrollTrans && <div className={styles.downrightimg} onClick={scrollToBottom}><img src={scrolldown}></img></div>}
                    </div>

                  </div>
                  
                </div >
              </div >
            </div >
          </div >
        )
        :
        (<CallsEditShareTrans gotoMainPage={backToCurrentPage}
          commonDetail={commonDetail} transcriptionDetails={transcriptShow} title={title}></CallsEditShareTrans>)
      }
    </>
  );
};